/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ReferralDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 30 21"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round">
      <polygon points="16.6666667 6 0.666666667 6 0.666666667 14 16.6666667 14 16.6666667 19.3333333 28 10 16.6666667 0.666666667" />
    </g>
  </svg>
);

export default ReferralDetailsIcon;
